import { render, staticRenderFns } from "./usergroup-dialog.vue?vue&type=template&id=4007c25d&scoped=true"
import script from "./usergroup-dialog.vue?vue&type=script&lang=js"
export * from "./usergroup-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4007c25d",
  null
  
)

export default component.exports